"use client";

import { Portal } from "@/lib/api";

interface HeaderProps {
  portals: Portal[];
  activePortal: string | null;
  onPortalClick: (name: string) => void;
  loading: boolean;
  username: string;
  onLogout: () => void;
}

export function Header({
  portals,
  activePortal,
  onPortalClick,
  loading,
  username,
  onLogout,
}: HeaderProps) {
  return (
    <header className="glass border-b border-blue-500/15 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center glow-blue">
            <span className="text-white font-bold text-lg">H</span>
          </div>
          <div>
            <h1 className="text-xl font-bold gradient-text">Hitmark</h1>
            <p className="text-xs text-muted-foreground">
              Kalkulator Leasingu
            </p>
          </div>
        </div>

        {/* Portal Buttons */}
        <div className="flex items-center gap-3">
          {portals.map((portal) => (
            <button
              key={portal.name}
              onClick={() => onPortalClick(portal.name)}
              disabled={loading}
              className={`
                relative px-6 py-2.5 rounded-xl font-semibold text-sm
                transition-smooth
                ${
                  activePortal === portal.name
                    ? "bg-blue-600 text-white glow-blue"
                    : "glass glass-hover text-blue-300 hover:text-white"
                }
                disabled:opacity-50 disabled:cursor-not-allowed
                hover:scale-105 active:scale-95
              `}
            >
              {loading && activePortal === portal.name && (
                <span className="absolute left-3 top-1/2 -translate-y-1/2">
                  <span className="spinner !w-4 !h-4" />
                </span>
              )}
              <span
                className={
                  loading && activePortal === portal.name ? "pl-5" : ""
                }
              >
                {portal.name}
              </span>
            </button>
          ))}
        </div>

        {/* User info & Logout */}
        <div className="flex items-center gap-3">
          <span className="text-sm text-muted-foreground">{username}</span>
          <button
            onClick={onLogout}
            className="px-4 py-2 rounded-xl text-sm glass glass-hover text-blue-300 hover:text-white transition-smooth hover:scale-105 active:scale-95"
          >
            Wyloguj
          </button>
        </div>
      </div>
    </header>
  );
}
